import ChargeItem from './Models/ChargeItem';
import PayItem from './Models/PayItem';
var JSONbig = require('json-bigint');

export class PosSystemApi {
    public async getCart(ftJourneyID: string): Promise<CartResponse | null> {
        try {
            let baseUrl = `https://possystem-api-sandbox.fiskaltrust.eu/v2/cart/${ftJourneyID}`;
            const response = await fetch(`${baseUrl}`, {
                method: "GET"
            });

            if (response.status === 204) {
                return null;
            }

            const responseText = await response.text();
            return JSONbig.parse(responseText) as CartResponse;
        } catch (error) {
            console.error("Error in signing:", error);
            throw error;
        }
    };

    public async authorize(ftJourneyID: string, paypalorderid: string): Promise<any> {
        try {
            let baseUrl = `https://possystem-api-sandbox.fiskaltrust.eu/v2/cart/${ftJourneyID}/authorize`;
            const response = await fetch(`${baseUrl}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    paypalorderid: paypalorderid,
                })
            });

            if (response.status === 204) {
                return null;
            }

            const responseText = await response.text();
            return JSONbig.parse(responseText);
        } catch (error) {
            console.error(error);
            alert(
                `Sorry, your transaction could not be processed...${error}`
            );
        }
    };
}

export interface CartResponse {
    ftJourneyID: string;
    DocumentURL: string;
    cbChargeItems: ChargeItem[];
    cbPayItems: PayItem[];
    DeliveryMethod: string;
    GiveAwayURL: string;
    ReceiptURL: string;
    State: string;
    cbTerminalID: string | null;
}